module.exports = __webpack_public_path__ + "img/C08TechAshokasVirtueRM_ua.6d9ed912.webp";